export default {
  data () {
    return {
      total_amount: 0,
      total_secondary_amount: 0,
    }
  },
  methods: {
    getTotal (response) {
      const { totals = {} } = response.data
      const { total_amount = 0, total_secondary_amount = 0 } = totals
      this.total_amount = total_amount
      this.total_secondary_amount = total_secondary_amount
    },
  },
}
